// Loader-data plumbing kept out of the product page UI so the statically
// bundled route definition does not pull the detail-page component tree into
// the entry chunk; the lazy route component imports it from here.
export type MarketProductResult<T> = { ok: true; data: T } | { ok: false };

export const toMarketProductResult = async <T>(
  promise: Promise<T>
): Promise<MarketProductResult<T>> => {
  try {
    return { ok: true, data: await promise };
  } catch {
    return { ok: false };
  }
};
